import React from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MultiSelect from "react-multi-select-component";
import { TfiAngleDown } from "react-icons/tfi";
import { IoClose } from "react-icons/io5";
import { PiCalendarBlank } from "react-icons/pi";
import swal from "sweetalert";
import instantAware from "../../../assets/create_campaign/instantAware.png"
import userReply from "../../../assets/create_campaign/userReply.png"
import credentialHarvesting from "../../../assets/create_campaign/credHarvesting.png"
import { featuresObj } from "../../../globalData";
import axios from "../../../axios";
import axiosLib from "axios";
import apiError from "../../../error";
import { toast } from "react-toastify";
import { resolveAwarenessTargetedGroupForInstantOn } from "../awareness-defaults";
import IVRvishingIcon from "../../../assets/create_campaign/IVR.png";
import AIVishingIcon from "../../../assets/create_campaign/ai-conversational.png";
import whatsappImgIVR from "../../../assets/create_campaign/whatsapp-ivr.png";
import whatsappImgChatbox from "../../../assets/create_campaign/chatbox.png";

import "./steps.css";
import "../launch-new-modal.css";

const getMinCustomExpiryDate = () => {
	const date = new Date();
	date.setDate(date.getDate() + 1);
	date.setHours(0, 0, 0, 0);
	return date;
};

const parseCustomExpiryDate = (value) => {
	if (!value) return null;
	if (value instanceof Date && !isNaN(value.getTime())) return value;
	const trimmed = String(value).trim();
	if (!trimmed) return null;
	const isoMatch = trimmed.match(
		/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?/
	);
	if (isoMatch) {
		const parsed = new Date(
			Number(isoMatch[1]),
			Number(isoMatch[2]) - 1,
			Number(isoMatch[3]),
			isoMatch[4] != null ? Number(isoMatch[4]) : 0,
			isoMatch[5] != null ? Number(isoMatch[5]) : 0,
			isoMatch[6] != null ? Number(isoMatch[6]) : 0
		);
		return isNaN(parsed.getTime()) ? null : parsed;
	}
	const parsed = new Date(trimmed);
	return isNaN(parsed.getTime()) ? null : parsed;
};

const formatCustomExpiryDate = (date) => {
	if (!date || !(date instanceof Date) || isNaN(date.getTime())) return null;
	const pad = (n) => String(n).padStart(2, "0");
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
};

const CampaignDetailsExpiryDateInput = React.forwardRef(
	({ value, onClick, onChange, onFocus }, ref) => (
		<button
			type="button"
			className="campaign-run-mode-datepicker-trigger"
			onClick={onClick}
			onFocus={onFocus}
			ref={ref}
		>
			<span className="campaign-run-mode-datepicker-trigger__icon" aria-hidden="true">
				<PiCalendarBlank />
			</span>
			<input
				type="text"
				className="campaign-run-mode-datepicker-trigger__field"
				value={value}
				onChange={onChange}
				onClick={onClick}
				onFocus={onFocus}
				placeholder="DD/MM/YYYY / hh:mm"
				readOnly
			/>
		</button>
	)
);
CampaignDetailsExpiryDateInput.displayName = "CampaignDetailsExpiryDateInput";

const getCancelSource = () => {
	const CancelToken = axiosLib.CancelToken;
	return CancelToken ? CancelToken.source() : null;
};

/** Align IVR vs AI with `targetInteractionType` when `isAIbased` is omitted (common from template APIs). */
export function deriveVishingModeFromDetails(cd) {
	const rawTit = cd?.targetInteractionType;
	const tit = rawTit != null ? String(rawTit).trim().toLowerCase() : "";
	let isAIbased = false;
	let targetInteractionType =
		cd?.targetInteractionType !== undefined && cd?.targetInteractionType !== null
			? cd.targetInteractionType
			: "";

	if (cd?.isAIbased === true || cd?.isAIbased === false) {
		isAIbased = cd.isAIbased;
		targetInteractionType = cd.isAIbased ? "inbound" : "outbound";
	} else if (tit === "inbound") {
		isAIbased = true;
	} else if (tit === "outbound") {
		isAIbased = false;
	}

	if ((!targetInteractionType || String(targetInteractionType).trim() === "") && (isAIbased === true || isAIbased === false)) {
		targetInteractionType = isAIbased ? "inbound" : "outbound";
	}

	return { isAIbased, targetInteractionType };
}

export default class CampaignDetailsStep extends React.Component {
	constructor(props) {
		super(props);
		this.groupRequestCancel = null;
		this._isMounted = false;
		const instantAw =
			props.campaignDetails?.instantAwareness !== undefined
				? !!props.campaignDetails.instantAwareness
				: false;
		this.state = {
			campaignName: props.campaignDetails?.campaignName || "",
			selectedOptions: props.campaignDetails?.targetGroups || [],
			groupIds: props.campaignDetails?.targetGroups?.map(item => item.value) || [],
			instantAwareness: instantAw,
			userReply: props.campaignDetails?.userReply !== undefined ? props.campaignDetails.userReply : false,
			// Use ?? not || so false from campaignDetails is preserved (|| would fall through to props.credentialHarvesting).
			credentialHarvesting: !!(props.campaignDetails?.credentialHarvesting ?? props.credentialHarvesting ?? false),
			expiryDays: props.campaignDetails?.expiryDays !== undefined ? props.campaignDetails.expiryDays : 7,
			customExpiryDate: props.campaignDetails?.customExpiryDate || null,
			awarenessTargetedGroup: resolveAwarenessTargetedGroupForInstantOn(
				props.simulationType,
				props.attackType,
				instantAw,
				props.campaignDetails?.awarenessTargetedGroup
			),
			timeFrame: props.campaignDetails?.timeFrame || "1",
			isRepliedCampaign: props.campaignDetails?.isRepliedCampaign !== undefined ? props.campaignDetails.isRepliedCampaign : false,
			userReplyFeature: featuresObj['reply-tracking-over-phishing'],
			...deriveVishingModeFromDetails(props.campaignDetails),
			groups: [],
			errors: {
				campaignName: "",
				targetGroups: "",
				customExpiryDate: "",
				awarenessTargetedGroup: ""
			}
		};
	}

	componentDidMount() {
		this._isMounted = true;
		if (!this.props.followUpMode) this.loadGroups();
		const parentAg = this.props.campaignDetails?.awarenessTargetedGroup || "";
		if (this.state.awarenessTargetedGroup !== parentAg) {
			this.updateData();
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (this.groupRequestCancel) {
			this.groupRequestCancel();
		}
	}

	loadGroups = () => {
		const source = getCancelSource();
		if (source) this.groupRequestCancel = source.cancel;
		axios.get('/api/groups/parentGroup', { cancelToken: source ? source.token : undefined })
			.then((res) => {
				var groups = [];
				for (var i = 0; i < res.data.groups.length; i++) {
					if (res.data.groups[i].targets > 0) {
						groups.push({
							value: res.data.groups[i].id,
							label: res.data.groups[i].name + " ( " + res.data.groups[i].targets + " Members )"
						});
					}
				}
				this.setState({ groups: groups });
			})
			.catch((err) => {
				if (!axiosLib.isCancel(err)) apiError(err);
			});
	}

	handleGroupChange = (selected) => {
		const groupIds = selected.map(item => item.value);
		this.setState({ 
			selectedOptions: selected,
			groupIds: groupIds,
			errors: { ...this.state.errors, targetGroups: "" }
		}, () => {
			this.updateData();
		});
	}

	handleCampaignNameChange = (e) => {
		const value = e.target.value;
		this.setState({ 
			campaignName: value,
			errors: { ...this.state.errors, campaignName: "" }
		}, () => {
			this.updateData();
		});
	}


	handleToggle = (field) => {
		if (field === "instantAwareness") {
			const nextInstant = !this.state.instantAwareness;
			this.setState(
				(prev) => ({
					instantAwareness: nextInstant,
					awarenessTargetedGroup: resolveAwarenessTargetedGroupForInstantOn(
						this.props.simulationType,
						this.props.attackType,
						nextInstant,
						prev.awarenessTargetedGroup
					),
				}),
				() => this.updateData()
			);
			return;
		}
		if (field === "credentialHarvesting") {
			const nextCredentialHarvesting = !this.state.credentialHarvesting;
			this.setState(
				(prev) => ({
					credentialHarvesting: nextCredentialHarvesting,
					// "Data Submitted" needs credential harvesting on (except Vishing, which only ever offers that option); fall back to "Link Clicked" when it's turned off.
					awarenessTargetedGroup:
						!nextCredentialHarvesting &&
						prev.awarenessTargetedGroup === "datasubmitted" &&
						this.props.attackType !== "Vishing"
							? "linkclicked"
							: prev.awarenessTargetedGroup,
				}),
				() => this.updateData()
			);
			return;
		}
		this.setState({ [field]: !this.state[field] }, () => {
			this.updateData();
		});
	}

	handleReplyTo = async () => {
		try {
			const willSuccess = await swal({
				title: "Make sure IMAP is setup correctly in your account",
				icon: "info",
				buttons: ["Not Now!", "Yes"],
			});
			if (willSuccess && this._isMounted) {
				this.setState({ isRepliedCampaign: true, userReply: true }, () => {
					this.updateData();
				});
			}
		} catch (err) {
			// Avoid breaking the flow if the dialog is dismissed unexpectedly.
			return;
		}
	}

	handleExpiryOptionChange = (option) => {
		if (option === '7days') {
			this.setState({
				expiryDays: 7,
				customExpiryDate: null,
				errors: { ...this.state.errors, customExpiryDate: "" }
			}, () => {
				this.updateData();
			});
		} else if (option === '15days') {
			this.setState({
				expiryDays: 15,
				customExpiryDate: null,
				errors: { ...this.state.errors, customExpiryDate: "" }
			}, () => {
				this.updateData();
			});
		} else if (option === 'custom') {
			this.setState({
				expiryDays: 'custom',
				customExpiryDate: null,
				errors: { ...this.state.errors, customExpiryDate: "" }
			}, () => {
				this.updateData();
			});
		}
	}

	hasValidCustomExpiryDate = () => {
		const value = this.state.customExpiryDate;
		if (value === null || value === undefined) return false;
		if (typeof value === "string") return value.trim().length > 0;
		return true;
	}

	updateData = () => {
		if (typeof this.props.onUpdate !== "function") return;
		try {
			const payload = {
				campaignName: this.state.campaignName ?? "",
				targetGroups: Array.isArray(this.state.selectedOptions) ? this.state.selectedOptions : [],
				instantAwareness: !!this.state.instantAwareness,
				userReply: this.state.userReply !== false,
				credentialHarvesting: !!this.state.credentialHarvesting,
				expiryDays: this.state.expiryDays,
				customExpiryDate: this.state.customExpiryDate,
				awarenessTargetedGroup: this.state.awarenessTargetedGroup ?? "",
				timeFrame: this.state.timeFrame ?? "1",
				isRepliedCampaign: !!this.state.isRepliedCampaign,
				isAIbased: !!this.state.isAIbased,
				targetInteractionType: this.state.targetInteractionType ?? "",
			};
			this.props.onUpdate(payload);
		} catch (err) {
			console.error("CampaignDetailsStep updateData", err);
		}
	}

	validate = () => {
		if (this.props.followUpMode) {
			const errors = {
				...this.state.errors,
				customExpiryDate: "",
				awarenessTargetedGroup: ""
			};
			if (this.state.expiryDays === "custom" && !this.hasValidCustomExpiryDate()) {
				errors.customExpiryDate = "Please select a custom expiry date";
				this.setState({ errors });
				toast.error("Please select a custom expiry date");
				return false;
			}

			if (
				this.props.simulationType === "Simulation Attack + Training" &&
				!String(this.state.awarenessTargetedGroup || "").trim()
			) {
				errors.awarenessTargetedGroup = "Please select awareness targeted group";
				this.setState({ errors });
				toast.error("Please select awareness targeted group");
				return false;
			}

			this.setState({ errors });
			return true;
		}

		const errors = {
			campaignName: "",
			targetGroups: "",
			customExpiryDate: "",
			awarenessTargetedGroup: ""
		};

		if (!this.state.campaignName || this.state.campaignName.trim().length === 0) {
			errors.campaignName = "Campaign name is required";
		}

		if (!this.state.selectedOptions || this.state.selectedOptions.length === 0) {
			errors.targetGroups = "Please select at least one target group";
		}

		if (this.state.expiryDays === "custom" && !this.hasValidCustomExpiryDate()) {
			errors.customExpiryDate = "Please select a custom expiry date";
		}

		if (
			this.props.simulationType === "Simulation Attack + Training" &&
			!String(this.state.awarenessTargetedGroup || "").trim()
		) {
			errors.awarenessTargetedGroup = "Please select awareness targeted group";
		}

		this.setState({ errors });
		const isValid = !errors.campaignName && !errors.targetGroups && !errors.customExpiryDate && !errors.awarenessTargetedGroup;
		
		// Update parent if validation fails
		if (!isValid && typeof this.props.onUpdate === "function") {
			this.props.onUpdate({
				campaignName: this.state.campaignName,
				targetGroups: this.state.selectedOptions,
				instantAwareness: this.state.instantAwareness,
				userReply: this.state.userReply,
				credentialHarvesting: this.state.credentialHarvesting,
				expiryDays: this.state.expiryDays,
				customExpiryDate: this.state.customExpiryDate,
				awarenessTargetedGroup: this.state.awarenessTargetedGroup,
				timeFrame: this.state.timeFrame,
				isRepliedCampaign: this.state.isRepliedCampaign
			});
		}
		
		return isValid;
	}

	componentDidUpdate(prevProps) {
		// Update userReplyFeature when package is fetched
		if (this.props.isPackageFetched !== prevProps.isPackageFetched && this.props.isPackageFetched) {
			this.setState({ userReplyFeature: featuresObj['reply-tracking-over-phishing'] });
		}
		
		if (prevProps.campaignDetails !== this.props.campaignDetails) {
			// Must match constructor: default false when parent omits the field (was `: true`, which forced ON on every campaignDetails sync).
			const instantAw =
				this.props.campaignDetails?.instantAwareness !== undefined
					? !!this.props.campaignDetails.instantAwareness
					: false;
			const awarenessTargetedGroup = resolveAwarenessTargetedGroupForInstantOn(
				this.props.simulationType,
				this.props.attackType,
				instantAw,
				this.props.campaignDetails?.awarenessTargetedGroup
			);
			const parentAwareness = this.props.campaignDetails?.awarenessTargetedGroup || "";
			this.setState({
				campaignName: this.props.campaignDetails?.campaignName || "",
				selectedOptions: this.props.campaignDetails?.targetGroups || [],
				groupIds: this.props.campaignDetails?.targetGroups?.map(item => item.value) || [],
				instantAwareness: instantAw,
				userReply: this.props.campaignDetails?.userReply !== undefined ? this.props.campaignDetails.userReply : true,
				credentialHarvesting: this.props.campaignDetails?.credentialHarvesting !== undefined && this.props.campaignDetails?.credentialHarvesting !== null
					? !!this.props.campaignDetails.credentialHarvesting
					: !!(this.props.credentialHarvesting ?? false),
				expiryDays: this.props.campaignDetails?.expiryDays !== undefined ? this.props.campaignDetails.expiryDays : 7,
				customExpiryDate: this.props.campaignDetails?.customExpiryDate || null,
				awarenessTargetedGroup,
				timeFrame: this.props.campaignDetails?.timeFrame || "1",
				isRepliedCampaign: this.props.campaignDetails?.isRepliedCampaign !== undefined ? this.props.campaignDetails.isRepliedCampaign : false,
				...deriveVishingModeFromDetails(this.props.campaignDetails),
			}, () => {
				if (
					this.props.followUpMode &&
					awarenessTargetedGroup !== parentAwareness
				) {
					this.updateData();
				}
			});
		} else if (
			prevProps.attackType !== this.props.attackType ||
			prevProps.simulationType !== this.props.simulationType
		) {
			this.setState(
				(prev) => ({
					awarenessTargetedGroup: resolveAwarenessTargetedGroupForInstantOn(
						this.props.simulationType,
						this.props.attackType,
						prev.instantAwareness,
						prev.awarenessTargetedGroup
					),
				}),
				() => this.updateData()
			);
		}
	}
	handleAIbased(value) {
		this.setState(
			{
				isAIbased: value,
				targetInteractionType: value ? "inbound" : "outbound"
			},
			() => this.updateData()
		);
	}

	/** Outbound / IVR vs inbound / AI — aligns with template step when `targetInteractionType` is blank or oddly cased. */
	isVishingOutboundMode = () => {
		if (this.props.attackType !== "Vishing") return false;
		const raw = this.state.targetInteractionType;
		const t = raw != null ? String(raw).trim().toLowerCase() : "";
		if (t === "outbound") return true;
		if (t === "inbound") return false;
		return this.state.isAIbased !== true;
	};

	isVishingInboundMode = () =>
		this.props.attackType === "Vishing" && !this.isVishingOutboundMode();

	/** WhatsApp AI conversational path (inbound). User Reply applies here; Direct WhatsApp is outbound. */
	isAiWhatsappInboundMode = () => {
		if (this.props.attackType !== "WhatsApp") return false;
		const tit = this.state.targetInteractionType != null
			? String(this.state.targetInteractionType).trim().toLowerCase()
			: "";
		if (tit === "inbound") return true;
		if (tit === "outbound") return false;
		return this.state.isAIbased === true;
	};

	render() {
		const followUpMode = this.props.followUpMode === true;
		/**
		 * WhatsApp / Vishing: same rule for follow-up and for Create Campaign from a prefilled template
		 * (e.g. template preview): only the non-selected mode looks disabled; the chosen mode stays active.
		 * Do not use prefilledFromTemplate alone on both cards — that muted both options.
		 */
		const modeUiAttack =
			this.props.attackType === "WhatsApp" || this.props.attackType === "Vishing";
		const lockModeChoice =
			modeUiAttack && (this.props.prefilledFromTemplate || followUpMode);
		const outboundStyleCardLocked =
			lockModeChoice && this.state.isAIbased === true;
		const inboundAiCardLocked =
			lockModeChoice && this.state.isAIbased === false;

		return (
			<div className="step-content-wrapper">
				<div className="step-header">
					<h4>{followUpMode ? "Configuration" : "Campaign Details"}</h4>
					<p>{followUpMode ? "Configure the essential settings required to run the follow-up campaign" : "Define the basic details and settings for your simulation campaign."}</p>
				</div>
				<div className="campaign-details-form">
					<div className="form-section">
						{!followUpMode && <h5 className="section-title">Information</h5>}
						{!followUpMode && (
							<div className="form-row-side-by-side mb-3">
								<Form.Group className="form-group-half">
									<Form.Label>Campaign Name<span className="red-star">*</span></Form.Label>
									<Form.Control type="text" isInvalid={this.state.errors.campaignName} placeholder="Campaign name" value={this.state.campaignName} onChange={e => this.setState({ campaignName: e.target.value, errors: { ...this.state.errors, campaignName: "" } }, () => this.updateData())} />
									{this.state.errors.campaignName && (
										<Form.Control.Feedback type="invalid" className="invalid-feedback-block">
											{this.state.errors.campaignName}
										</Form.Control.Feedback>
									)}
								</Form.Group>
								<Form.Group className="form-group-half">
									<Form.Label>Select Target Groups<span className="red-star">*</span></Form.Label>
									<div className="user-groups-wrapper">
										<MultiSelect
											className={this.state.errors.targetGroups ? "multi-select empty" : "multi-select borderRemove"}
											options={this.state.groups}
											value={this.state.selectedOptions}
											onChange={this.handleGroupChange}
											ClearSelectedIcon={null}
											ArrowRenderer={() => (
												<TfiAngleDown className="down-arrow-campaign" />
											)}
											valueRenderer={(selected) => {
												if (!selected || selected.length === 0) return "Select target groups";
												return (
													<span className="multi-select-value-badges d-flex flex-wrap align-items-center gap-1">
														{selected.map((item) => (
															<span key={item.value} className="badge badge-soft-primary mr-1 badge-with-close">
																{item.label}
																<IoClose
																	className="badge-close-icon"
																	onClick={(e) => {
																		e.stopPropagation();
																		this.handleGroupChange(selected.filter((s) => s.value !== item.value));
																	}}
																	aria-label="Remove"
																/>
															</span>
														))}
													</span>
												);
											}}
											overrideStrings={{ selectSomeItems: "Select target groups" }}
										/>
									</div>
									{this.state.errors.targetGroups && (
										<div className="invalid-feedback invalid-feedback-block">
											{this.state.errors.targetGroups}
										</div>
									)}
								</Form.Group>
							</div>
						)}
						<Form.Label>Campaign Expiry<span className="red-star">*</span></Form.Label>
						<Form.Group>
							<div className="campRadiobtn d-flex justify-content-start align-items-center flex-wrap mb-2">
								<Form.Check 
									type="radio" 
									name="expiryOption"
									onChange={() => this.handleExpiryOptionChange('7days')} 
									label="7 Days" 
									checked={this.state.expiryDays === 7} 
								/>
								<Form.Check 
									type="radio" 
									name="expiryOption"
									onChange={() => this.handleExpiryOptionChange('15days')} 
									label="15 Days" 
									checked={this.state.expiryDays === 15} 
								/>
								<div className="custom-expiry-date-wrapper">
									<Form.Check 
										type="radio" 
										name="expiryOption"
										onChange={() => this.handleExpiryOptionChange('custom')} 
										label="Custom" 
										checked={this.state.expiryDays === 'custom'} 
									/>
									{this.state.expiryDays === 'custom' && (
										<div className="custom-expiry-date-field ml-2">
											<div
												className={`campaign-details-expiry-datepicker${
													this.state.errors.customExpiryDate
														? " campaign-details-expiry-datepicker--error"
														: ""
												}`}
											>
												<div className="campaign-run-mode-datepicker-input-shell">
													<DatePicker
														selected={parseCustomExpiryDate(
															this.state.customExpiryDate
														)}
														onChange={(date) =>
															this.setState(
																{
																	customExpiryDate:
																		formatCustomExpiryDate(date),
																	errors: {
																		...this.state.errors,
																		customExpiryDate: "",
																	},
																},
																() => this.updateData()
															)
														}
														minDate={getMinCustomExpiryDate()}
														showTimeInput
														timeInputLabel="Time"
														dateFormat="dd/MM/yyyy hh:mm aa"
														customInput={
															<CampaignDetailsExpiryDateInput />
														}
														calendarClassName="campaign-run-mode-datepicker-calendar"
														popperClassName="campaign-run-mode-datepicker-popper"
														popperPlacement="bottom-start"
														popperModifiers={{
															offset: {
																enabled: true,
																offset: "0, 8",
															},
														}}
													/>
												</div>
											</div>
											{this.state.errors.customExpiryDate && (
												<div className="custom-expiry-date-error invalid-feedback-block">
													{this.state.errors.customExpiryDate}
												</div>
											)}
										</div>
									)}
								</div>
							</div>
						</Form.Group>
					</div>
					{this.props.attackType === "Vishing" && 
						<div className="form-section">
							<h5 className="section-title">Vishing Mode</h5>
							<div className="vishing-options-wrapper mt-3">
								<div className="row">
									<div className="col-md-6 mb-3">
											<div
											className={`vishing-card ${!this.state.isAIbased ? 'active' : ''}${outboundStyleCardLocked ? ' disabled' : ''}`}
											onClick={() => !outboundStyleCardLocked && this.handleAIbased(false)}
											style={{ cursor: outboundStyleCardLocked ? 'not-allowed' : '' }}
											aria-disabled={outboundStyleCardLocked}
										>
											<div className="vishing-img-wrapper">
												<img src={IVRvishingIcon} alt="IVR" />
											</div>
											<div className="vishing-content">
												<div className="vishing-title">IVR (Keypad-based)</div>
												<div className="vishing-desc">Automated pre-recorded calls that attempt to extract information using keypad inputs</div>
											</div>
											<div className="vishing-radio">
												<input type="radio" checked={this.state.isAIbased === false} readOnly />
											</div>
										</div>
									</div>
									<div className="col-md-6 mb-3">
											<div
											className={`vishing-card ${this.state.isAIbased === true ? 'active' : ''}${inboundAiCardLocked ? ' disabled' : ''}`}
											onClick={() => !inboundAiCardLocked && this.handleAIbased(true)}
											style={{ cursor: inboundAiCardLocked ? 'not-allowed' : '' }}
											aria-disabled={inboundAiCardLocked}
										>
											<div className="vishing-img-wrapper">
												<img src={AIVishingIcon} alt="AI" />
											</div>
											<div className="vishing-content">
												<div className="vishing-title">AI Conversational (Voice Bot)</div>
												<div className="vishing-desc">Human-like AI voice interaction that dynamically engages users to extract sensitive information.</div>
											</div>
											<div className="vishing-radio">
												<input type="radio" checked={this.state.isAIbased === true} readOnly />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					}
					{this.props.attackType === "WhatsApp" &&
						<div className="form-section">
							<h5 className="section-title">WhatsApp Phishing Mode</h5>
							<div className="vishing-options-wrapper mt-3">
								<div className="row">
									<div className="col-md-6 mb-3">
										<div
											className={`vishing-card ${!this.state.isAIbased ? 'active' : ''}${outboundStyleCardLocked ? ' disabled' : ''}`}
											onClick={() => !outboundStyleCardLocked && this.handleAIbased(false)}
											style={{ cursor: outboundStyleCardLocked ? 'not-allowed' : '' }}
											aria-disabled={outboundStyleCardLocked}
										>
											<div className="vishing-img-wrapper">
												<img src={whatsappImgIVR} alt="WhatsApp"  />
											</div>
											<div className="vishing-content">
												<div className="vishing-title"> Direct WhatsApp Message</div>
												<div className="vishing-desc">Send tracked WhatsApp messages through the configured gateway</div>
											</div>
											<div className="vishing-radio">
												<input type="radio" checked={this.state.isAIbased === false} readOnly />
											</div>
										</div>
									</div>
									<div className="col-md-6 mb-3">
										<div
											className={`vishing-card ${this.state.isAIbased === true ? 'active' : ''}${inboundAiCardLocked ? ' disabled' : ''}`}
											onClick={() => !inboundAiCardLocked && this.handleAIbased(true)}
											style={{ cursor: inboundAiCardLocked ? 'not-allowed' : '' }}
											aria-disabled={inboundAiCardLocked}
										>
											<div className="vishing-img-wrapper">
												<img src={whatsappImgChatbox} alt="AI WhatsApp" />
											</div>
											<div className="vishing-content">
												<div className="vishing-title">AI Conversational (Chat Bot)</div>
												<div className="vishing-desc">Send an email with a WhatsApp link, then continue the interaction in AI chat</div>
											</div>
											<div className="vishing-radio">
												<input type="radio" checked={this.state.isAIbased === true} readOnly />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					}
					
					{!this.isVishingOutboundMode() &&
						<div className="form-section">
							{!followUpMode && <h5 className="section-title">Configuration</h5>}
							<div className="toggle-options">
								{this.props.simulationType === "Simulation Attack + Training" && this.props.attackType !== "Attachment" && (
									<div className="toggle-option">
										<div className="toggle-option-content">
											<div className="toggle-icon">
												<img src={instantAware} alt="Instant Awareness" />
											</div>
											<div className="toggle-text">
												<h6>Instant Awareness</h6>
												<p>Allows users to immediately access TLMS and complete their learning</p>
											</div>
										</div>
										<Form.Check
											type="switch"
											id="instantAwareness"
											checked={this.state.instantAwareness}
											onChange={() => this.handleToggle('instantAwareness')}
										/>
									</div>
								)}
					{(this.props.attackType === 'Phishing' || this.props.attackType === 'Ransomware' || this.props.attackType === 'Attachment' || this.props.attackType === 'QRcode' || this.isVishingInboundMode() || this.isAiWhatsappInboundMode()) && (
						<OverlayTrigger
							placement="top"
							overlay={
								!(this.props.userReplyFeature !== undefined ? this.props.userReplyFeature : this.state.userReplyFeature) ? (
									<Tooltip id="top">Upgrade your plan</Tooltip>
								) : (
									<Tooltip id="top" className="d-none" />
								)
							}
						>
							<div className="toggle-option">
								<div className="toggle-option-content">
									<div className="toggle-icon">
										<img src={userReply} alt="User Reply" />
									</div>
									<div className="toggle-text">
										<h6>User Reply</h6>
										<p>
											{this.props.attackType === "WhatsApp" && this.isAiWhatsappInboundMode()
												? "Captures replies when users respond during the inbound WhatsApp / AI chat simulation."
												: "Captures responses when users reply to the phishing email during the campaign."}
										</p>
									</div>
								</div>
								<Form.Check
									type="switch"
									id="isRepliedCampaign"
									checked={this.state.isRepliedCampaign}
									disabled={!(this.props.userReplyFeature !== undefined ? this.props.userReplyFeature : this.state.userReplyFeature)}
									onChange={() => {
										if (!this.state.isRepliedCampaign) {
											this.handleReplyTo();
										} else {
											this.handleToggle('isRepliedCampaign');
										}
									}}
								/>
							</div>
						</OverlayTrigger>
					)}{(this.props.attackType !== 'Attachment' && this.props.attackType !== 'Ransomware' && !this.isVishingOutboundMode()) && (() => {
								const credentialHarvestingLocked = !!(this.props.prefilledFromTemplate && this.props.templateMissingLandingPage);
								return (
								<div className="toggle-option">
									<div className="toggle-option-content">
										<div className="toggle-icon">
											<img src={credentialHarvesting} alt="Credential Harvesting" />
										</div>
										<div className="toggle-text">
											<h6>Credential Harvesting</h6>
											<p>Simulate credential submission to identify users who attempt to share login information</p>
										</div>
									</div>
									<OverlayTrigger
										placement="top"
										overlay={
											credentialHarvestingLocked ? (
												<Tooltip id="credential-harvesting-no-landing-page">
													This template does not have a landing page, so Credential Harvesting is not applicable. Hence, it cannot be enabled for templates without a landing page.
												</Tooltip>
											) : (
												<Tooltip id="credential-harvesting-no-landing-page" className="d-none" />
											)
										}
									>
										<span className="d-inline-block">
											<Form.Check
												type="switch"
												id="credentialHarvesting"
												checked={this.state.credentialHarvesting}
												disabled={credentialHarvestingLocked}
												onChange={() => this.handleToggle('credentialHarvesting')}
												style={credentialHarvestingLocked ? { pointerEvents: "none" } : undefined}
											/>
										</span>
									</OverlayTrigger>
								</div>
								);
							})()}
								
							</div>
						</div>
					}
					{this.props.simulationType === "Simulation Attack + Training"  &&  (
						<div className="form-section">
							<h5 className="section-title">Training Configuration</h5>
							<div className="form-row-side-by-side">
								<Form.Group className="form-group-half">
									<Form.Label>Awareness Targeted Group <span className="red-star">*</span></Form.Label>
									<Form.Control 
										as="select" 
										isInvalid={!!this.state.errors.awarenessTargetedGroup}
										value={this.state.awarenessTargetedGroup} 
										onChange={e => this.setState({
											awarenessTargetedGroup: e.target.value,
											errors: { ...this.state.errors, awarenessTargetedGroup: "" }
										}, () => this.updateData())}
									>
										<option value="">Select Awareness Targeted Group</option>
										{this.props.attackType === "Attachment" ? (
											<option value="Attachment Opened">Attachment Opened</option>
										) : (this.props.attackType === "Vishing") ? (
											<option value="datasubmitted">Data Submitted</option>
										) : (
											<>
												<option value="linkclicked">Link Clicked</option>
												<option value="datasubmitted" disabled={this.state.credentialHarvesting ? false : true}>Data Submitted</option>
											</>
										)}
									</Form.Control>
									{this.state.errors.awarenessTargetedGroup && (
										<Form.Control.Feedback type="invalid" className="invalid-feedback-block">
											{this.state.errors.awarenessTargetedGroup}
										</Form.Control.Feedback>
									)}
								</Form.Group>
								{!this.state.instantAwareness && (
									<Form.Group className="form-group-half">
										<Form.Label>Time Frame</Form.Label>
										<Form.Control 
											as="select" 
											value={this.state.timeFrame} 
											onChange={e => this.setState({ timeFrame: e.target.value }, () => this.updateData())}
										>
											<option value="1">1 sec</option>
											<option value="5">5 min</option>
											<option value="10">10 min</option>
											<option value="15">15 min</option>
										</Form.Control>
									</Form.Group>
								)}
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}
